<template src='./PackageConfig.html'></template>

<script>
import { mapState } from "vuex";
// const { mapState } = createNamespacedHelpers("packageConfig");
import { ValidatorInstaller } from "@progress/kendo-validator-vue-wrapper";

Vue.use(ValidatorInstaller);
import Vue from "vue";
// import { state } from "../../store/entities";
export default {
  data: function() {
    return {
      name: [
        { name: "Gold", id: 1 },
        { name: "Silver", id: 2 },
        { name: "Bronze", id: 3 }
      ],
      product: [],
      editField: this.$route.params.add,
      defaultItem: {
        name: "--Select--"
      },
      PackData: [],

      data: {},
      selectedField: "selected",
      staticColumns: [{ field: "name", title: "Module Name", width: "250px" }],
    };
  },
  mounted() {
    this.DataOnload();
  },
  methods: {
    DataOnload() {
      this.$store.dispatch("packageConfig/getModule").then(async () => {
        this.PackData = await this.$store.getters["packageConfig/packModule"];
        if(this.PackData && this.PackData.length>0 && this.data && this.data.modules) {
        this.PackData.forEach(item => {
          this.data.modules.filter(obj => {
            if (obj.id === item.id) {
              item.selected = true;
              item.features.forEach(feature => {
                obj.features.filter(data => {
                if (feature.id === data.id) {
                  feature.checkFeatureSelected = true;
                }
                });
              })
            }
          });
        });
      }
      });
    },
    comparer(otherArray) {
      return function(current) {
        return (
          otherArray.filter(function(other) {
            return (
              other.value == current.value && other.display == current.display
            );
          }).length == 0
        );
      };
    },
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      Vue.set(
        this,
        "PackData",
        this.PackData.map(item => {
          return { ...item, selected: checked };
        })
      );
    },
    onSelectionChange(event) {
      Vue.set(
        event.dataItem,
        this.selectedField,
        !event.dataItem[this.selectedField]
      );
    },
    checkFeature(event, id, moduleId) {
      let checked = event.target.checked;
      this.PackData.forEach(item => {
        if(item.id == moduleId) {
        item.features.forEach(feature => {
          if(feature.id == id) {
            feature.checkFeatureSelected = checked;
          }
        });
        }
      });
    },
    checkExtraFeature(event, id) {
      let checked = event.target.checked;
      this.extraFeaturesData.forEach(item => {
          if(item.id == id) {
            item.checkExtraFeatureSelected = checked;
          }
      });
    },
    onRowClick(event) {
      Vue.set(
        event.dataItem,
        this.selectedField,
        !event.dataItem[this.selectedField]
      );
    },
    createRandomData() {
      return;
    },
    goToListPage: function() {
      this.$store.commit("packageConfig/cancel");
      this.$router.push({ name: "Package" });
    },
    addForm() {
      var t = this.PackData;
      var value = [];
      t.map(item => {
        if (item.selected === true) value.push({ ID: item.id, features:item.features.filter(item =>item.checkFeatureSelected == true) });
      });
      // for (var i = 0; i < t.length; i++) {
      //   if (t[i].selected === true) {
      //     var value
      //     values.push({ ID: item });
      // console.log(value);
      //     // if (t[i] !== undefined) state.LeftTeamData.push(t[i]);
      //   }
      // }
      if (this.data.name && this.data.product) {
        let dataVal = {
          Name: this.data.name.name,
          productID: this.data.product.id,
          Modules: value,
          extraFeatures:this.extraFeaturesData && this.extraFeaturesData.length>0 ? this.extraFeaturesData.filter(item =>item.checkExtraFeatureSelected == true) : [],
        };

        if (!this.editField) {
          this.$store
            .dispatch("packageConfig/addPackage", dataVal)
            .then(async () => {
              await this.$router.push({ name: "Package" });
            });
        } else {
          dataVal.id = this.data.id;
          this.$store
            .dispatch("packageConfig/updatePackage", dataVal)
            .then(async () => {
              this.$router.push({ name: "Package", params: { add: false } });
            });
        }
      }
    }
  },

  computed: {
    ...mapState(["features"]),
    areAllSelected() {
      return this.PackData.findIndex(item => item.selected === false) === -1;
    },
    columns() {
      return [
        {
          field: "selected",
          width: "40px",
          headerSelectionValue: this.areAllSelected
        },
        ...this.staticColumns
      ];
    },
    moduleData() {
       return this.PackData && this.PackData.length>0 ? this.PackData.filter(item =>item.selected == true) : [];
    },
    extraFeaturesData() {
      let tempPackData = this.PackData && this.PackData.length>0 ? this.PackData.filter(item =>item.selected == true) : [];
      let newFeatureData = this.features;
      if(tempPackData && tempPackData.length>0) {
      tempPackData.forEach(data => {
        data.features.forEach(item => {
          newFeatureData = newFeatureData.filter(feature =>feature.id != item.id)
          });
        });
      }
      let newData = newFeatureData;
       return newData;
    },
  },
  created: function() {
    this.DataOnload();
  },
  beforeMount() {
    this.product = this.$store.getters["allProducts"];
    this.data = this.$store.getters["packageConfig/newPackage"];

    if (this.data != {}) {
      this.data.name = this.name.find(obj => obj.name == this.data.name);
      this.data.product = this.product.find(
        obj => obj.id == this.data.productID
      );
    }
  }
};
</script>

<style>
.main-section {
  display: flex;
  flex-direction: row;
}
.feature-section {
  display: flex;
  max-height: 400px;
  width:550px;
  border: 1px solid #e8e8e8;
  margin-left: 1rem;
  overflow: auto;
  flex-direction: column;
}
.feature-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 1rem;
}
.feature-name {
  width: 100%;
  display: flex;
  font-size: 14px;
  height: 35px;
  position: sticky;
  color: #fff;
  background-color: #043d96;
  align-items: center;
  padding: 0 0.5rem;
}
.feature-list-section {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.empty-feature-list {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.feature-list-items {
  height: 30px;
  border: 1px solid #e8e8e8;
  padding: 0 0.5rem;
  font-size: 13px;
  display: flex;
  align-items: center;
}
.p-l-1 {
  padding-left: 0.5rem;
}
</style>